import React, { useState, useImperativeHandle } from 'react'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField';

//helpers
import Api from '../../../__helpers/api'

//images
import loader from '../../../assets/images/contacts/loader.svg'

//actions
import { refreshGroups } from '../../../__actions/instructor'

//dispatcher
import { useSelector, useDispatch } from 'react-redux'

function AddGroup(props, ref) {
    const dispatch = useDispatch()

    useImperativeHandle(ref, () => ({
        show: (id, name) => handleShow(id, name),
        hide: () => handleHide()
    }))

    const initialData = {
        id: null,
        name: ''
    }

    const [data, setData] = useState({
        loading: false,
        blur: false,
        show: false,
        ...initialData
    })

    const handleShow = (id, name) => {
        setData(prev => ({
            ...prev,
            blur: true,
            id,
            name
        }))

        setTimeout(() => {
            setData(prev => ({
                ...prev,
                blur: true,
                show: true
            }))
        }, 50)

    }

    const handleHide = () => {
        setData(prev => ({
            ...prev,
            show: false
        }))

        setTimeout(() => {
            setData(prev => ({
                ...prev,
                show: false,
                blur: false,
                ...initialData
            }))
        }, 100)
    }

    const handleSubmit = e => {
        e.preventDefault()

        const formData = new FormData(e.target)

        const url = data.id ? 'center/groups/edit' : 'center/groups/add'

        if (data.id) {
            formData.append('id', data.id)
        }

        Api.post(url, formData)
            .then(res => {
                handleHide()
                dispatch(refreshGroups())
            })
            .catch(err => {
                alert('Грешка')
            })
    }

    const handleChange = e => {
        const name = e.target.name
        const value = e.target.value

        setData(prev => ({
            ...prev,
            [name]: value
        }))
    }


    return (
        <>
            <div ref={ref} id="overlay" className={data.blur ? 'visible' : ''}>
                <form className={`box settings ${data.show ? 'show' : ''}`} style={{ maxWidth: '600px' }} onSubmit={handleSubmit}>
                    <h3>
                        Добавяне на теоретична група
                    </h3>
                    <br />
                    <div className="fields">
                        <TextField
                            label="Име или номер"
                            placeholder="Въведете име или номер"
                            fullWidth={true}
                            type="text"
                            name="name"
                            value={data.name}
                            onChange={handleChange}
                            inputProps={{
                                maxLength: 10
                            }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </div>
                    {!data.loading ?
                        <div className="buttons">
                            <Button className="cancel-request" onClick={handleHide}>
                                Отказ
                            </Button>
                            <Button type="submit" className="accept-request">
                                Добавяне
                            </Button>
                        </div>
                        :
                        <img src={loader} alt="loader" className="loader" />
                    }
                </form>
            </div>
        </>
    )
}

export default React.forwardRef(AddGroup);